import React from "react";
import { Route } from "react-router-dom";
import Media from "react-media";
import { Subscription } from 'rxjs'
import { Button, TextField } from "@material-ui/core";
import { IApplicationsDto } from "../../models/ApplicationsDto";
import { IApplicationDto } from "../../models/ApplicationDto";
import { ApplicationsState } from "../../../src/states/ApplicationsState";
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import { Paginator } from "../../components/paginator/Paginator";
import ApplicationTile from "../../components/application-tile/ApplicationTile";
import ConfirmDialog from "../../components/dialog/ConfirmDialog";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { MposLoader } from "../../components/loader/MposLoader";
import "./Applications.scss";

export class Applications extends React.Component<any, ApplicationsState> {

  private getActivatedAppsSubscription: Subscription | null = null;
  private getNotActivatedAppsSubscription: Subscription | null = null;
  private rowsPerPage: number;

  constructor(props: any) {
    super(props);
    this.state = {
      applicationList: [],
      applicationListCont: 0,
      appToDelete: null,
      showRemoveAppResultDialog: false,
      removeAppResult: false,
      vatNumber: "",
      pointOfSales: "",
      buttonDisabled: true,
      showLoader: false,
      developerId: "",
      page: 0,
      selectedAppDetails: null,
      controller: false,
      resultFilter: []
    }

    this.handleVatNumberOnChanges = this.handleVatNumberOnChanges.bind(this);
    this.handlePointOfSalesOnChanges = this.handlePointOfSalesOnChanges.bind(this);

    this.rowsPerPage = 6;

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleFirstPageButtonClick = this.handleFirstPageButtonClick.bind(this);
    this.handlePrevPageButtonClick = this.handlePrevPageButtonClick.bind(this);
    this.handleNextPageButtonClick = this.handleNextPageButtonClick.bind(this);
    this.handleLastPageButtonClick = this.handleLastPageButtonClick.bind(this);
  }

  componentDidMount() {
    console.log("[Application] fetching data...");

    const payload = {
      numElements: 999,
      numPage: 1,
      puntoVendita: '',
      pIva: '',
    }

    this.getActivatedAppsSubscription = MposWebPortalApi.getInstance().getApps(payload).subscribe((applicationsDto: IApplicationsDto) => {
      const applications = applicationsDto !== null && applicationsDto.Apps !== null ? applicationsDto.Apps! : [];
      this.setState({
        applicationList: applications,
        applicationListCont: applications.length
      });
    }, (error) => {
      this.setState({ applicationList: [] });
    });
    GoogleTagManagerService.getInstance().pushPageEvent(this.props.location.pathname, "Visualizza le tue applicazioni", {});
  }

  componentWillUnmount() {
    if (this.getActivatedAppsSubscription != null) {
      this.getActivatedAppsSubscription.unsubscribe();
    }

    if (this.getNotActivatedAppsSubscription != null) {
      this.getNotActivatedAppsSubscription.unsubscribe();
    }
  }

  private isFiledValidated(): boolean {
    return this.state.vatNumber !== '' || this.state.pointOfSales !== '';
  }

  private handleFieldValidation() {
    if (this.isFiledValidated()) {
      this.setState({ buttonDisabled: false });
    } else {
      this.setState({ buttonDisabled: true });
    }
  }

  private goToAppDetail(history: any, app: IApplicationDto) {
    const test = this.state.applicationList?.find((el) => el.appName === app.appName);
    if (test) {
      let link = `/applications/${app.appName}`;
      history.push(link, {
        app: app
      });
    }
  }

  private renderDesktopHeader() {
    return (
      <HeaderDesktop showBack={false} showLogout={true} showTitle={false} selectedElement={4} />
    );
  }

  private renderMobileHeader() {
    return (
      <HeaderMobile showBack={true} showLogout={true} showTitle={true} title="Le tue applicazioni" />
    );
  }

  private noApplication() {
    return (
      <div className="application-no-app">
        <p>Non sono presenti applicazioni.</p>
      </div>
    );
  }

  private filterApp(vatNumber: string | null, pointOfSales: string | null) {
    this.setState({ showLoader: true });

    const payload = {
      puntoVendita: pointOfSales,
      pIva: vatNumber,
      numElements: 999,
      numPage: 1,
    }

    MposWebPortalApi
      .getInstance()
      .getApps(payload)
      .subscribe((result) => {
        this.setState({
          applicationList: result.Apps,
          applicationListCont: result.totalNumApps,
          showLoader: false
        });
      },
        (error) => {
          this.setState({ showLoader: false });
        });
  }

  handleVatNumberOnChanges(event: any) {
    const newVatNumebr = event.target.value;
    this.setState({ vatNumber: newVatNumebr }, () => {
      // Controllo se entrambi i campi di ricerca sono vuoti
      if (this.state.vatNumber === '' && newVatNumebr === '') {
        const applicationList = this.state.applicationList || [];
        this.setState({
          controller: false, // Imposto controller a false per mostrare l'elenco iniziale
          resultFilter: [], // Resetto il risultato del filtro
          applicationList: applicationList, // Reimposto l'elenco delle applicazioni
        });
      }
    });
  }

  handlePointOfSalesOnChanges(event: any) {
    const newPointOfSales = event.target.value;
    this.setState({ pointOfSales: newPointOfSales }, () => {
      // Controllo se entrambi i campi di ricerca sono vuoti
      if (this.state.vatNumber === '' && newPointOfSales === '') {
        const applicationList = this.state.applicationList || [];
        this.setState({
          controller: false, // Imposto controller a false per mostrare l'elenco iniziale
          resultFilter: [], // Resetto il risultato del filtro
          applicationList: applicationList, // Reimposto l'elenco delle applicazioni
        });
      }
    });
  }

  handleChangePage = (event: any, newPage: number) => {
    this.setState({ page: newPage });
  };

  handleFirstPageButtonClick(): void {
    this.setState({ page: 0 });
  }

  handlePrevPageButtonClick(): void {
    this.setState((prevState) => ({ page: prevState.page - 1 }));
  }

  handleNextPageButtonClick(): void {
    this.setState((prevState) => ({ page: prevState.page + 1 }));
  }

  handleLastPageButtonClick(state: any): void {
    this.setState({ page: Math.ceil(state / this.rowsPerPage) - 1 });
  }

  toggleDeleteAppModal = () => {
    this.setState({
      showRemoveAppResultDialog: !this.state.showRemoveAppResultDialog,
    });
  };

  invokeDeleteApp() {
    this.setState({ showLoader: true });
    MposWebPortalApi.getInstance()
      .deleteApp(this.state.appToDelete!.appId)
      .subscribe(
        () => {
          this.setState({
            showLoader: false,
            showRemoveAppResultDialog: true,
            removeAppResult: true
          });
          this.showDeleteAppResult();
        },
        () => {
          this.setState({
            showLoader: false,
            showRemoveAppResultDialog: true,
            removeAppResult: false
          });
          this.showDeleteAppResult();
        }
      );
  }

  showDeleteAppResult() {
    this.props.history.push("/result", {
      isSuccess: this.state.removeAppResult,
      title: `Hai eliminato l'applicazione ${this.state.appToDelete?.appName}`,
      message: "",
      button: "Torna alla lista applicazioni",
      data: { from: "Applications", operation: "deleteApp" },
    });
  }

  private startAddAppFlow(history: any) {
    history.push('/addApp');
  }

  render() {
    return (
      <>
        {
          // @ts-ignore
          <MposLoader show={this.state.showLoader} />
        }
        <div id="main-container-application">
          <Media query="(max-width: 1064px)" render={() => this.renderMobileHeader()} />
          <Media query="(min-width: 1065px)" render={() => this.renderDesktopHeader()} />
          <div className="application-container">
            <p className="application-title">Visualizza le tue applicazioni.</p>
            <div className="application-filter-container">
              <div className="application-filter-field">
                <TextField
                  id="application-search-field"
                  label="P.IVA"
                  type="text"
                  value={this.state.vatNumber}
                  onChange={this.handleVatNumberOnChanges}
                  onBlur={() => this.handleFieldValidation()}
                />
              </div>
              <div className="application-filter-field">
                <TextField
                  id="application-search-field"
                  label="Punto vendita"
                  type="text"
                  value={this.state.pointOfSales}
                  onChange={this.handlePointOfSalesOnChanges}
                  onBlur={() => this.handleFieldValidation()}
                />
              </div>
              <div className="application-filter-field">
                <Button
                  className="application-search-button"
                  type="submit"
                  onClick={() => this.filterApp(this.state.vatNumber, this.state.pointOfSales)}
                  disabled={this.state.buttonDisabled}
                >
                  CERCA
                </Button>
              </div>
            </div>
            <div className="application-list-title-container">
              <p className="application-list-title">LISTA APPLICAZIONI</p>
              <Route render={({ history }) => {
                return (
                  <Button
                    className="add-new-application"
                    type={"button"}
                    onClick={() => this.startAddAppFlow(history)}
                  >
                    CREA APPLICAZIONE
                  </Button>
                )
              }} />
            </div>
            <Paginator
              data={this.state.applicationList}
              page={this.state.page}
              count={this.state.applicationListCont}
              rowsPerPage={this.rowsPerPage}
              handleChangePage={(event: any, newPage: number) => this.handleChangePage(event, newPage)}
              handleFirstPageButtonClick={() => this.handleFirstPageButtonClick()}
              handlePrevPageButtonClick={() => this.handlePrevPageButtonClick()}
              handleNextPageButtonClick={() => this.handleNextPageButtonClick()}
              handleLastPageButtonClick={() => this.handleLastPageButtonClick(this.state.applicationListCont)}
            />
            <div className="applciation-list">
              {this.state.controller ? (
                this.state.resultFilter?.map((app: IApplicationDto, i: any) => (
                  <Route key={i} render={({ history }) => {
                    return (
                      <ApplicationTile
                        id={app.appId}
                        name={app.appName}
                        onClick={() => this.goToAppDetail(history, app)}
                        removeOnClick={() => {
                          this.toggleDeleteAppModal();
                          this.setState({
                            appToDelete: app
                          });
                        }}
                      />
                    );
                  }} />
                ))
              ) : (
                this.state.applicationList!.length > 0 ? (
                  this.state.applicationList?.slice(this.state.page * this.rowsPerPage, this.state.page * this.rowsPerPage + this.rowsPerPage).map((app: IApplicationDto, i: any) => (
                    <Route key={i} render={({ history }) => {
                      return (
                        <ApplicationTile
                          id={app.appId}
                          name={app.appName}
                          onClick={() => this.goToAppDetail(history, app)}
                          removeOnClick={() => {
                            this.toggleDeleteAppModal();
                            this.setState({
                              appToDelete: app
                            });
                          }}
                        />
                      );
                    }} />
                  ))
                ) : this.noApplication()
              )}
            </div>

          </div>
        </div>
        <ConfirmDialog
          id="app-delete-confirm-dialog"
          show={this.state.showRemoveAppResultDialog}
          onClose={() => this.toggleDeleteAppModal()}
          title="Eliminazione App"
          content={`Sei sicuro di voler eliminare l'applicazione ${this.state.appToDelete?.appName}?`}
          buttonNoText="ANNULLA"
          buttonYesText="CONFERMA"
          onConfirm={() => this.invokeDeleteApp()}
        />
      </>
    )
  }
};
